import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 40.368a3 3 0 0 0 2.737 2.989c4.871.429 9.3.643 13.286.643 3.981 0 8.395-.214 13.241-.642A3 3 0 0 0 40 40.37V12a2 2 0 0 0-2-2H10a3.982 3.982 0 0 1-2-.535v30.903ZM10 2h28a4 4 0 0 1 4 4 1 1 0 1 1-2 0 2 2 0 0 0-2-2H10a2 2 0 1 0 0 4h28a4 4 0 0 1 4 4v28.37a5 5 0 0 1-4.56 4.98c-4.902.433-9.374.65-13.417.65-4.048 0-8.535-.217-13.462-.651A5 5 0 0 1 6 40.369V6a4 4 0 0 1 4-4Zm14 36c2.645 0 5.29-.296 7.937-.888a2.343 2.343 0 0 0 1.643-3.207l-.683-1.6a3 3 0 0 0-2.249-1.778C28.614 30.177 26.398 30 24 30c-2.398 0-4.614.176-6.648.527a3 3 0 0 0-2.249 1.778l-.683 1.6a2.343 2.343 0 0 0 1.643 3.207C18.71 37.704 21.356 38 24 38Zm0 2a38.26 38.26 0 0 1-8.373-.936 4.341 4.341 0 0 1-3.047-5.944l.684-1.6a5 5 0 0 1 3.747-2.964C19.162 28.186 21.491 28 24 28c2.509 0 4.838.185 6.989.556a5 5 0 0 1 3.747 2.964l.684 1.6a4.343 4.343 0 0 1-3.046 5.944A38.26 38.26 0 0 1 24 40Zm-4-20c0 2.206 1.793 4 4 4 2.206 0 4-1.793 4-4 0-2.206-1.793-4-4-4-2.206 0-4 1.793-4 4Zm-2 0c0-3.312 2.69-6 6-6 3.312 0 6 2.69 6 6 0 3.312-2.69 6-6 6-3.312 0-6-2.69-6-6Z",
      clipRule: "evenodd"
    }
  )
);
var SvgContactsOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ContactsOutlined_default = SvgContactsOutlined;

export { ContactsOutlined_default as default };
